import { KeyValue } from "@/main/models/common";
import React, { createContext, useContext, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";

interface IInsurerRegisterContext {
	hasScreenBranch: boolean;
	setHasScreenBranch: (value: boolean) => void;
	isEdit: boolean;
	setIsEdit: (value: boolean) => void;
	isAddBranch: boolean;
	setIsAddBranch: (value: boolean) => void;
	typeCompany: ITypeCompany;
	changeTypeCompany: (value: ITypeCompany) => void;
	displaySaveBranchWithHeadquarter: (country: string | undefined, headquarterKey: string) => void;
	displayEditBranchWithHeadquarter: (country: string | undefined, guidHeadquarter: string) => void;
	displayEditHeadquarter: () => void;
}

interface IInsurerRegisterProvider {
	children: React.ReactNode;
}

// Interface to react-hook-form
const INITIAL_FORM_STATE = {
	country: null,
	companyName: "",
	companyNameHeadquarter: null,
	rfc: "",
	status: null,
	tradeName: "",
	primaryColor: undefined,
	headerColor: undefined,
};
export interface IInsurerRegisterForm {
	country: KeyValue | null | undefined;
	companyName: string;
	rfc: string;
	status: KeyValue | null;
	companyNameHeadquarter: KeyValue | null;
	tradeName: string;
	primaryColor?: string;
	headerColor?: string;
}

export type ITypeCompany = "headquarters" | "branch";

const InsurerRegisterContext = createContext<IInsurerRegisterContext>({
	hasScreenBranch: false,
	setHasScreenBranch: () => {},
	isEdit: false,
	setIsEdit: () => {},
	isAddBranch: false,
	setIsAddBranch: () => {},
	typeCompany: "headquarters",
	changeTypeCompany: () => {},
	displaySaveBranchWithHeadquarter: () => {},
	displayEditBranchWithHeadquarter: () => {},
	displayEditHeadquarter: () => {},
});

function InsurerRegisterProvider({ children }: IInsurerRegisterProvider) {
	const methods = useForm<IInsurerRegisterForm>({
		mode: "onChange",
		defaultValues: INITIAL_FORM_STATE,
	});

	const [hasScreenBranch, setHasScreenBranch] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [isAddBranch, setIsAddBranch] = useState(false);
	const [typeCompany, setTypeCompany] = useState<ITypeCompany>("headquarters");

	// function displaySaveHeadquarter() { }
	// function displaySaveBranch() { }

	async function displaySaveBranchWithHeadquarter() {}

	async function displayEditBranchWithHeadquarter() {}

	function displayEditHeadquarter() {
		setIsEdit(true);
		setTypeCompany("headquarters");
	}

	// function displayEditBranch() { }

	function changeTypeCompany(value: ITypeCompany) {
		setTypeCompany(value);

		if (value === "headquarters") {
			methods.setValue("companyNameHeadquarter", null);
		}
	}

	return (
		<FormProvider {...methods}>
			<InsurerRegisterContext.Provider
				value={{
					hasScreenBranch,
					isEdit,
					isAddBranch,
					setHasScreenBranch,
					setIsAddBranch,
					setIsEdit,
					typeCompany,
					changeTypeCompany,
					displaySaveBranchWithHeadquarter,
					displayEditBranchWithHeadquarter,
					displayEditHeadquarter,
				}}
			>
				{children}
			</InsurerRegisterContext.Provider>
		</FormProvider>
	);
}

const useInsurerRegisterContext = () => useContext(InsurerRegisterContext);

export { InsurerRegisterProvider, useInsurerRegisterContext };
